import type { View } from "../components/Sidebar";

/**
 * Ansicht, Filter und geöffnete Mail stehen in der Adresszeile — so bleibt
 * nach dem Neuladen (oder dem Update-Hinweis) alles, wo es war, und ein Link
 * auf einen Ordner lässt sich in einem neuen Tab öffnen.
 *
 *   /?ansicht=f:12&ungelesen=1&von=max@firma.de&q=rechnung&mail=4711
 *
 * Geschrieben wird mit replaceState: Filterwechsel füllen nicht den Verlauf.
 * Die Zurück-Taste bleibt den Ebenen auf dem Telefon vorbehalten (App.tsx).
 */

const SMART: Record<string, string> = {
  antworten: "Zu beantworten",
  needsAction: "Vorschläge",
  unread: "Ungelesen",
  hoch: "Dringend",
  drafts: "Entwürfe",
};
const SEITEN: Record<string, string> = {
  aufgaben: "Aufgaben",
  belege: "Belege & USt",
  rules: "Regeln",
  stats: "Auswertung",
  einrichtung: "Einstellungen",
};

export interface AdressStand {
  view: View | null;
  ungelesen: boolean;
  von: string | null;
  suche: string;
  mail: number | null;
}

function ansichtAus(wert: string | null): View | null {
  if (!wert) return null;
  const [art, rest = ""] = [wert.slice(0, 1), wert.slice(2)];
  if (wert[1] !== ":" || !rest) return null;
  if (art === "f" && /^\d+$/.test(rest)) return { kind: "folder", folderId: Number(rest), label: "" };
  if (art === "s" && SMART[rest]) return { kind: "smart", id: rest as Extract<View, { kind: "smart" }>["id"], label: SMART[rest]! };
  if (art === "c" && /^[a-z]+$/.test(rest)) return { kind: "category", category: rest, label: rest[0]!.toUpperCase() + rest.slice(1) };
  if (art === "p" && SEITEN[rest]) return { kind: "page", id: rest as Extract<View, { kind: "page" }>["id"], label: SEITEN[rest]! };
  return null;
}

export function adresseLesen(): AdressStand {
  const p = new URLSearchParams(window.location.search);
  const mail = Number(p.get("mail"));
  return {
    view: ansichtAus(p.get("ansicht")),
    ungelesen: p.get("ungelesen") === "1",
    von: p.get("von") || null,
    suche: p.get("q") ?? "",
    mail: Number.isInteger(mail) && mail > 0 ? mail : null,
  };
}

/** Schreibt den Stand in die Adresse; `schluessel` ist ansichtSchluessel() aus App.tsx. */
export function adresseSchreiben(stand: { schluessel: string; start: string; ungelesen: boolean; von: string | null; suche: string; mail: number | null }): void {
  const p = new URLSearchParams();
  if (stand.schluessel !== stand.start) p.set("ansicht", stand.schluessel);
  if (stand.ungelesen) p.set("ungelesen", "1");
  if (stand.von) p.set("von", stand.von);
  if (stand.suche) p.set("q", stand.suche);
  if (stand.mail !== null) p.set("mail", String(stand.mail));
  const text = p.toString();
  const ziel = `${window.location.pathname}${text ? `?${text}` : ""}${window.location.hash}`;
  if (ziel !== `${window.location.pathname}${window.location.search}${window.location.hash}`) {
    // Den Verlaufszustand behalten — daran hängen die Ebenen der Zurück-Taste.
    window.history.replaceState(window.history.state, "", ziel);
  }
}
